import { IconType } from "Icons/types";

import { css } from "@emotion/react";

import { ButtonWrapper } from "components/shared/library/ButtonWrapper";
import { Typography } from "components/shared/library/Typography";

import { useJobSearch } from "utils/jobsSearch";

import { purple, uiGray } from "constants/colors";

const style = {
  card: css({
    width: 140,
    height: 138,
    padding: 16,
    borderRadius: 8,
    border: `1px solid ${uiGray[10]}`,
  }),
  wrapper: css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
  }),
  iconWrapper: css({
    background: purple[100],
    borderRadius: 100,
    padding: 16,
    display: "flex",
    gap: 10,
  }),
  hidden: css({ display: "hidden" }),
};

export const JobSectionCard = ({
  title,
  Icon,
}: {
  title: string;
  Icon: IconType;
}) => {
  const { goToGroup } = useJobSearch();

  return (
    <>
      <ButtonWrapper
        customCss={[style.card]}
        onClick={() => goToGroup(title)}
        ariaLabel={title}
      >
        <div css={style.wrapper}>
          <div css={style.iconWrapper}>
            <Icon stroke={purple[600]} />
          </div>
          <Typography weight="medium">{title}</Typography>
        </div>
      </ButtonWrapper>
    </>
  );
};
